import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dialogDefaultVariants = {
  "size": "md",
  "scrollType": "body"
}
const dialogCompoundVariants = [
  {
    "scrollType": "body",
    "size": "xs",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  },
  {
    "scrollType": "body",
    "size": "sm",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  },
  {
    "scrollType": "body",
    "size": "md",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  },
  {
    "scrollType": "body",
    "size": "lg",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  },
  {
    "scrollType": "body",
    "size": "xl",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  },
  {
    "scrollType": "body",
    "size": "full",
    "css": {
      "content": {
        "maxHeight": "85vh"
      }
    }
  }
]

const dialogSlotNames = [
  [
    "root",
    "dialog__root"
  ],
  [
    "trigger",
    "dialog__trigger"
  ],
  [
    "overlay",
    "dialog__overlay"
  ],
  [
    "content",
    "dialog__content"
  ],
  [
    "header",
    "dialog__header"
  ],
  [
    "title",
    "dialog__title"
  ],
  [
    "close",
    "dialog__close"
  ],
  [
    "footer",
    "dialog__footer"
  ],
  [
    "body",
    "dialog__body"
  ],
  [
    "description",
    "dialog__description"
  ]
]
const dialogSlotFns = /* @__PURE__ */ dialogSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dialogDefaultVariants, getSlotCompoundVariant(dialogCompoundVariants, slotName))])

const dialogFn = memo((props = {}) => {
  return Object.fromEntries(dialogSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dialogVariantKeys = [
  "scrollType",
  "size"
]
const getVariantProps = (variants) => ({ ...dialogDefaultVariants, ...compact(variants) })

export const dialog = /* @__PURE__ */ Object.assign(dialogFn, {
  __recipe__: false,
  __name__: 'dialog',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: dialogVariantKeys,
  variantMap: {
  "scrollType": [
    "body",
    "overlay"
  ],
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "full"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, dialogVariantKeys)
  },
  getVariantProps
})